<template>
  <div class="container">
    <div class="body">
      <v-text-field
        autofocus
        filled
        background-color="textBoxBackground"
        label="Name"
        style="height: 66px"
        v-model="userEditObj.display_name"></v-text-field>
      <v-textarea
        filled
        height="400"
        no-resize
        background-color="textBoxBackground"
        label="Description"
        v-model="userEditObj.description"></v-textarea>
      <div
        v-if="userEditObj?.uid || userEditObj?.template_uid"
        class="uid-subtle with-tick">
        <small>
          <code
            @click="copyUid"
            class="clickable-uid">
            {{ userEditObj.uid || userEditObj.template_uid }}
          </code>
        </small>
        <span
          class="copied-tick"
          v-if="copied">
          <v-icon small>mdi-check</v-icon>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
const props = defineProps(['userEditObj']);
const copied = ref(false);

async function copyUid() {
  const uid = props.userEditObj?.uid || props.userEditObj?.template_uid || '';
  if (!uid) return;
  try {
    await navigator.clipboard.writeText(uid);
    copied.value = true;
    setTimeout(() => (copied.value = false), 1400);
  } catch (e) {
    const ta = document.createElement('textarea');
    ta.value = uid;
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
      copied.value = true;
      setTimeout(() => (copied.value = false), 1400);
    } catch (err) {
      console.error('copy failed', err);
    }
    ta.remove();
  }
}
</script>

<style scoped>
.uid-subtle {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.5);
  font-family:
    ui-monospace, SFMono-Regular, Menlo, Monaco, 'Roboto Mono', 'Courier New',
    monospace;
  font-size: 13px;
  word-break: break-all;
}
.uid-subtle code {
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
}
.clickable-uid {
  cursor: pointer;
}
.with-tick {
  display: flex;
  align-items: center;
  gap: 8px;
}
.copied-tick {
  color: rgba(255, 255, 255, 0.8);
}
</style>
